import React from "react";

const SkeletonCell: React.FC = () => {
    return (
        <div className="loading w-100">
            <div className="bar" />
        </div>
    );
};

export default SkeletonCell;
